import Controller from '../controller/controller';
export default class App {
    init() {
        this.controller = new Controller();
    }
}
